import { createFeatureSelector, createSelector } from '@ngrx/store';

import { KN_BR_CONTEXT_CUSTOMER_FEATURE, KnBrCustomerContextState } from './kn-br-customer-context.state';

export const getCustomerContextState = createFeatureSelector<KnBrCustomerContextState>(KN_BR_CONTEXT_CUSTOMER_FEATURE);

export const getCustomerContext = createSelector(getCustomerContextState, (state: KnBrCustomerContextState) =>
  state ? state.customerContext : null
);
